import getters from './product/getters'
import mutations from './product/mutations'
import actions from './product/actions'

const state = {
  id: null,
  slug: null,
  sellerId: null,
  ownerId: null,
  storeId: null,
  planId: null,
  categories: null,
  seoCategory: null,
  currentUserId: null,
  offer: {},
  photos: [],
  size: null,
  used: null,
  purchase: {},
  regularPrice: {
    colors_classes: {},
    values: {
      price: {}
    }
  },
  timerPrice: null,
  isFlashSale: null,
  title: '',
  description: '',
  storeProductsPath: '',
  relatedProductsPath: '',
  relatedProductsQuery: '',
  navigationHistoryPath: '',
  fallbackPricing: {
    discount: 0,
    price: {},
    bundle_allowed: false,
    state: ''
  },
  subCategorySlug: '',
  brand: {},
  moreFromStore: {
    products: [],
    isFetching: true
  },
  relatedProducts: {
    products: [],
    isFetching: true
  },
  navigationHistory: {
    products: [],
    isFetching: true
  },
  variations: {
    labels: {},
    options: []
  },
  actions: {
    purchase: {
      visible: false,
      action: ''
    },
    add_product: {
      visible: false,
      action: ''
    },
    offer: {
      visible: false,
      action: ''
    },
    is_bottom_sheet_eligible: false
  },
  banner: {
    title: '',
    description: '',
    icon: ''
  },
  isProductSuggestionModalOpen: false,
  isFetchingPrice: true,
  isFetchingActions: false,
  isReady: false,
  hasFilledMetaTags: false,
  flashMessage: {},
  comments: {
    submit_allowed: false,
    replace_with_faq_url: ''
  },
  shipping: {
    type: null,
    label: null
  },
  isShippingPriceEnable: false,
  serviceTax: 0,
  singlePiece: false,
  hasCopiedCouponCode: false,
  similarProductInfo: null,
  relatedProductSearchId: '',
  setMoreFromStoreSearchId: ''
}

export default {
  state,
  getters,
  mutations,
  actions
}
